export function getCheckoutUrl(back: string) {
  return `/subscribe/checkout?back=${encodeURIComponent(back)}`;
}
